var getters = {
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  size: function size(state) {
    return state.app.size;
  },
  device: function device(state) {
    return state.app.device;
  },
  visitedViews: function visitedViews(state) {
    return state.tagsView.visitedViews;
  },
  cachedViews: function cachedViews(state) {
    return state.tagsView.cachedViews;
  },
  loginAccount: function loginAccount(state) {
    return state.user.loginAccount;
  },
  userCode: function userCode(state) {
    return state.user.userCode;
  },
  roles: function roles(state) {
    return state.user.roles;
  },
  token: function token(state) {
    return state.user.token;
  },
  storeLength: function storeLength(state) {
    return state.user.storeLength;
  },
  organizationInfo: function organizationInfo(state) {
    return state.user.organizationInfo;
  },
  superAdminFlag: function superAdminFlag(state) {
    return state.user.superAdminFlag;
  },
  permission_routes: function permission_routes(state) {
    return state.permission.routes;
  },
  sidebarRoutes: function sidebarRoutes(state) {
    return state.permission.sidebarRoutes;
  },
  selectedStore: function selectedStore(state) {
    return state.user.selectedStore;
  }
};
export default getters;